import { InjectionToken } from "@angular/core";
export const BASE_APP_HREF_FOR_OKTA = new InjectionToken('base-app-reference-for-okta');
export const TEMP_ROUTE = 'redirect';
export const WILD_CARD = 'wildCard';
export const getURLParams = function (str) {
    const urlParams = {};
    // check if url has query params
    if (str.indexOf("?") !== -1) {
        let match;
        const pl = /\+/g; // Regex for replacing addition symbol with a space
        const search = /([^&=]+)=?([^&]*)/g;
        const decode = function (s) {
            return decodeURIComponent(s.replace(pl, " "));
        };
        const query = str.split("?").pop();
        while (match = search.exec(query)) {
            if (decode(match[1]) in urlParams) {
                if (!Array.isArray(urlParams[decode(match[1])])) {
                    urlParams[decode(match[1])] = [urlParams[decode(match[1])]];
                }
                urlParams[decode(match[1])].push(decode(match[2]));
            }
            else {
                urlParams[decode(match[1])] = decode(match[2]);
            }
        }
        return urlParams;
    }
};
export const getCorrectEmailForLegacyUsers = function (oktaUserClaim) {
    const viacomEmailAddress = oktaUserClaim[Object.keys(oktaUserClaim).find((key) => key.toLowerCase() === 'viacomemailaddress')];
    return viacomEmailAddress ? viacomEmailAddress : oktaUserClaim.email;
};
//# sourceMappingURL=okta-utils.js.map